import React, { useCallback } from 'react';
import { Col, Row, Layout, Typography, Button } from 'antd';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import { LANGUAGE_ABBREVIATIONS } from '../../../constants';
import styles from './styles.module.css';

export function Header() {
  const { t, i18n } = useTranslation();

  const handleChangeLanguage = useCallback(
    (lng) => () => i18n.changeLanguage(lng),
    [i18n]
  );

  const isLTSelected = i18n.language === LANGUAGE_ABBREVIATIONS.LT;
  const isRuSelected = i18n.language === LANGUAGE_ABBREVIATIONS.RU;
  

  return (
    <Layout.Header className={styles.root}>
      <Row className={styles.wrap} gutter={24} align="middle">
        <Col xs={12}>
          <div className={styles.logoWrap}>
            <a href="/" className={styles.logoLink}>
              <img
                className={styles.logo}
                src="/hotrema-logo-1.png"
                alt="hotrema-logo"
              />
            </a>
            <img className={styles.kaizenLogo} src="/kaizen-logo.png" alt="kaizen company" />
            <Typography.Title className={styles.title} level={5}>
              {t('title.main')}
            </Typography.Title>
          </div>
        </Col>
        <Col xs={12} align="end">
          <Button
            className={cn(styles.button, {
              [styles.button__selected]: isLTSelected,
            })}
            type="text"
            selected={isLTSelected}
            onClick={handleChangeLanguage(LANGUAGE_ABBREVIATIONS.LT)}
          >
            Lt
          </Button>
          <Button
            className={cn(styles.button, {
              [styles.button__selected]: isRuSelected,
            })}
            type="text"
            selected={isRuSelected}
            onClick={handleChangeLanguage(LANGUAGE_ABBREVIATIONS.RU)}
          >
            Ru
          </Button>          
          
        </Col>
      </Row>
    </Layout.Header>
  );
}
